import { EventBus } from "@/lib/event-bus";

const state = {
  items: [],
  plans: [],
};

const getters = {
  inCart: (state) => (item) => {
    return state.items.some(_item => _item.id === item.id);
  },
  outright: (state) => {
    return state.items.reduce((acc, item) => {
      if (item.plan.outright) {
        return acc + item.plan.outright
      }
      return acc;
    }, 0);
  },
  upfront: () => {
    return state.items.reduce((acc, item) => {
      if (item.plan.upfront) return acc + item.plan.upfront;
      return acc;
    }, 0)
  },
  repayment: (state) => {
    const total = state.items.reduce((acc, item) => {
      if (item.plan?.monthly && item.plan?.duration) {
        return acc + (item.plan.monthly * item.plan.duration * item.plan.unit);
      }
      return acc;
    }, 0);
    const months = state.items.reduce((max, item) => {
      return max < item.plan?.duration ? item.plan?.duration : max
    }, 0);
    return {
      total,
      monthly: total ? total / months : 0,
      months
    }
  }
};

const mutations = {
  addItem: (state, item) => {
    const exists = state.items.some(_item => _item.id === item.id);
    if (exists) {
      state.items = state.items.map(_item => {
        if (_item.id === item.id) return item;
        return _item;
      });
    } else {
      state.items.push(item);
    }
  },
  removeItem: (state, id) => {
    state.items = state.items.filter(item => item.id !== id);
  },
  clear() {
    state.items = []
    state.plans = []
  }
};

const actions = {
  show() {
    EventBus.$emit('cart')
  }
};

const cart = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};

export default cart;
